import { render, staticRenderFns } from "./PayAuthorityComplain.vue?vue&type=template&id=1484f71d&scoped=true&"
import script from "./PayAuthorityComplain.vue?vue&type=script&lang=ts&"
export * from "./PayAuthorityComplain.vue?vue&type=script&lang=ts&"
import style0 from "./PayAuthorityComplain.vue?vue&type=style&index=0&id=1484f71d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1484f71d",
  null
  
)

export default component.exports